(function ($) {
    $(function () {
        function init() {
            if (localStorage.modalCovid == "true") {
                $(".covid-notice").hide()
                $('body').removeClass("covid-modal")
            } else {
                $(".covid-notice").show()
                $('body').addClass("covid-modal")
            }
            if (!$.fn.modal) {
                console.debug('$.fn.modal defined');
                $.fn.modal = function (args) {
                    let $modal = $(this);
                    let $close = $modal.find('.js-modal-close');

                    if (args === 'show') {
                        $('body').css('overflow', 'hidden');
                        $modal.fadeIn(200);
                    }

                    if (args === 'close') {
                        let removeOverflow = true;
                        $('.modal').each(function () {
                            if ($(this)[0] !== $modal[0] && $(this).css('display') !== 'none') {
                                removeOverflow = false;
                            }
                        })
                        if (removeOverflow) {
                            $('body').css('overflow', '');
                        }
                        $modal.fadeOut(200);
                    }

                    $modal.on('click', function (e) {
                        if (e.target !== this)
                            return;
                        e.preventDefault();
                        let removeOverflow = true;
                        $('.modal').each(function () {
                            if ($(this)[0] !== $modal[0] && $(this).css('display') !== 'none') {
                                removeOverflow = false;
                            }
                        })
                        if (removeOverflow) {
                            $('body').css('overflow', '');
                        }
                        $modal.fadeOut(200);
                    })

                    $close.on('click', function (e) {
                        e.preventDefault();
                        let removeOverflow = true;
                        $('.modal').each(function () {
                            if ($(this)[0] !== $modal[0] && $(this).css('display') !== 'none') {
                                removeOverflow = false;
                            }
                        })
                        if (removeOverflow) {
                            $('body').css('overflow', '');
                        }

                        $modal.fadeOut(200);
                    })

                    return this;
                };
            }

            const downloadableMedia = () => {
                $('.downloadable-media').on('click', function (e) {
                    e.preventDefault();
                    let fileUrl = $(this).data('fileUrl');
                    if( fileUrl ) {
                        if( fileUrl.indexOf('cdn.nmbtc.com/uploads') !== -1 ) {
                            fileUrl = fileUrl.replace('cdn.nmbtc.com/uploads', 'nmbtc.com/wp-content/uploads');
                        }

                        const a = document.createElement("a");
                        a.href = fileUrl;
                        a.download = fileUrl.split('/').reverse()[0];
                        a.click();
                    }
                });
            }

            const headerMobile = () => {
                const mobileMenu = $(".mobile-nav");
                $(".header__toggler, .close_menu_mobile").click(function (e) {
                    mobileMenu.toggleClass("active")
                    $("html").toggleClass("hidden")
                    $(".nav__item.search-box .sub-menu-box.search").removeClass("active")
                    e.preventDefault();
                })
                $(".nav__item.sub-menu-has > a").click(function (e) {
                    if ($(this).hasClass('active')) {
                        $(".nav__item.sub-menu-has > a").removeClass('active');
                    } else {
                        $(".nav__item.sub-menu-has > a").removeClass('active');
                        $(this).addClass('active');
                    }
                    $(this).parent().siblings().find(".sub-menu-box").removeClass("active");
                    $(this).next().toggleClass("active");
                    e.preventDefault();
                })

                $('body').on('click', function (e) {
                    if (!$(e.target).closest(".header__nav").length) {
                        $(".sub-menu-box:not(.search)").removeClass("active")
                    }
                    e.stopPropagation();
                });

                $(".sub-menu-has .icon-back-menu").click(function (e) {
                    $('.switch-menu-box').removeClass('active-box');
                    if ($(this).hasClass("product")) {
                        $(".group-menu-box").removeClass("active");
                        $(this).removeClass("product")
                    } else {
                        $(this).parent().removeClass("active")
                    }
                })
                $(".search__toggler ").click(function (e) {
                    mobileMenu.addClass("active")
                    $("html").addClass("hidden")
                    $(".nav__item.search-box .sub-menu-box.search").toggleClass("active")
                })
            }
            const menuBoxNavigation = () => {
                $('.switch-menu-box').on('click', function (e) {
                    if ($(this).hasClass('active-box')) {
                        return false;
                    }
                    const openBox = $(this).data('openBox');
                    if ($('[data-box="' + openBox + '"]').length) {
                        e.preventDefault();
                        $('.switch-menu-box').removeClass('active-box');
                        $(this).addClass('active-box');
                        $(this).closest('.sub-menu-box').find('.group-menu-box').removeClass('active');
                        $('[data-box="' + openBox + '"]').addClass('active');
                        $(this).parents(".sub-menu-box").find(".icon-back-menu").addClass("product")
                    }
                });
            }

            const openModal = (modalId) => {
                let $modal = $('#' + modalId);

                if ($modal.length) {
                    $modal.modal('show');
                } else {
                    console.error('Modal with #' + modalId + ' was missing in the DOM!')
                }
            }

            const setToLS = (key, value) => {
                let ls = window.localStorage;
                ls.setItem(key, value);
            }

            const pushToLS = (key, value, removeFirst) => {
                let ls = window.localStorage;
                let lsItems = ls.getItem(key);

                if (lsItems === null) {
                    lsItems = [value];
                } else {
                    lsItems = JSON.parse(lsItems)
                    if (lsItems.indexOf(value) === -1) {
                        lsItems.push(value);
                    }
                }

                if (removeFirst === true) {
                    lsItems.shift();
                }
                ls.setItem(key, JSON.stringify(lsItems));
            }
            const noticeCheck = () => {
                $('.notice').each(function () {
                    let $notice = $(this);
                    let id = $notice.data('id');
                    let ls = window.localStorage;
                    let lsNotices = ls.getItem('notices');
                    let lsAcceptCookies = ls.getItem('accept_cookies') === 'true';
                    if (id === 'notice_cookies') {
                        if (!lsAcceptCookies) {
                            $notice.fadeIn(200);
                        }
                    } else {
                        if (lsNotices === null) {
                            $notice.fadeIn(200);
                        } else {
                            lsNotices = JSON.parse(lsNotices);
                            if (lsNotices.indexOf(id) === -1) {
                                $notice.fadeIn(200);
                            }
                        }
                    }

                });
            }


            $(document).ready(function () {
                $('body').find('#pi_tracking_opt_in_div').attr('style', 'display: none;')
                $('body').removeClass('loading');
                $('.modal').each(function () {
                    $(this).modal();
                })
                const $searchBox = $('form.search_parts');
                const $searchBoxEol = $('form.search-eol');
                menuBoxNavigation();
                headerMobile();
                downloadableMedia();
                noticeCheck();

                $(window).scroll(function () {
                    var sticky = $('.header'),
                        scroll = $(window).scrollTop();

                    if (scroll >= 50) sticky.addClass('fixed');
                    else sticky.removeClass('fixed');
                });

                if ($searchBox.length) {
                    let searchHistory = localStorage.getItem('search_history');
                    let $suggestionsList = $searchBox.find('.js-suggestions-list');
                    let $searchInput = $searchBox.find('.js-search-input');

                    if (searchHistory !== null) {
                        searchHistory = JSON.parse(searchHistory)
                        searchHistory.forEach(search => {
                            let searchElement = document.createElement('a');
                            searchElement.href = '#';
                            searchElement.className = 'link link--bold link--inline search__suggestions-item';
                            searchElement.innerHTML = search;

                            $suggestionsList.append($(searchElement));
                        });
                    }

                    $searchInput.on('click', function () {
                        $(this).parents("form.search_parts").addClass('search--show-suggestions');
                    });

                    $('.search__suggestions-close').on('click', function (e) {
                        e.preventDefault();
                        $(this).parents("form.search_parts").removeClass('search--show-suggestions');
                    });
                    $(".clear-history").on('click', function (e) {
                        e.preventDefault();
                        searchHistory = localStorage.removeItem('search_history');
                        $(".search__suggestions-list").remove();
                    });

                    $(document).on('submit', 'form.search_parts', function (e) {
                        e.preventDefault();
                        let $form = $(this);
                        let $suggestionsList = $form.find('.js-suggestions-list');
                        let $searchInput = $form.find('.js-search-input');
                        let searchValue = $searchInput.val();
                        let searchParamName = $searchInput.attr('name');
                        let searchHistoryCount = parseInt($suggestionsList.data('count'));


                        let searchHistory = localStorage.getItem('search_history');
                        if (searchHistory === null) {
                            searchHistory = [];
                        } else {
                            searchHistory = JSON.parse(searchHistory)
                        }

                        if (searchHistory.length >= searchHistoryCount) {
                            pushToLS('search_history', searchValue, true);
                        } else {
                            pushToLS('search_history', searchValue);
                        }

                        $('body').addClass('loading');


                        if ('URLSearchParams' in window) {
                            var searchParams = new URLSearchParams(window.location.search);
                            searchParams.delete('cpage');
                            searchParams.set(searchParamName, searchValue);
                            window.location.href = $form.prop('action') + '?' + searchParams.toString()
                        }
                    });

                    $('body').on('click', '.js-suggestions-list a', function (e) {
                        e.preventDefault();
                        $searchInput.val($(this).text());
                        $searchBox.submit();
                    })

                    $(document).mouseup(function (e) {
                        if (!$searchBox.is(e.target) && $searchBox.has(e.target).length === 0) {
                            $searchBox.find(".search__suggestions-close").trigger("click")
                        }
                    });
                }

                if ($searchBoxEol.length) {
                    let searchHistoryEol = localStorage.getItem('search_history_eol');
                    let $suggestionsListEol = $searchBoxEol.find('.js-suggestions-list-eol');
                    let $searchInputEol = $searchBoxEol.find('.js-search-input');
                    if (searchHistoryEol !== null) {
                        searchHistoryEol = JSON.parse(searchHistoryEol)
                        searchHistoryEol.forEach(search => {
                            let searchElement = document.createElement('a');
                            searchElement.href = '#';
                            searchElement.className = 'link link--bold link--inline search__suggestions-item';
                            searchElement.innerHTML = search;
                            $suggestionsListEol.append($(searchElement));
                        });
                    }
                    $searchInputEol.on('click', function () {
                        $(this).parents("form.search-eol").addClass('search--show-suggestions');
                    });
                    $('.search__suggestions-close').on('click', function (e) {
                        e.preventDefault();
                        $(this).parents("form.search-eol").removeClass('search--show-suggestions');
                    });
                    $(".clear-history").on('click', function (e) {
                        e.preventDefault();
                        searchHistoryEOL = localStorage.removeItem('search_history_eol');
                        $("form.search-eol .search__suggestions-list").remove();
                    });
                    $(document).on('submit', 'form.search-eol', function (e) {
                        e.preventDefault();
                        let $form = $(this);
                        let $suggestionsListEol = $form.find('.js-suggestions-list-eol');
                        let $searchInputEol = $form.find('.js-search-input');
                        let searchValue = $searchInputEol.val().trim();
                        let searchParamName = $searchInputEol.attr('name');
                        let searchHistoryEOLCount = parseInt($suggestionsListEol.data('count'));
                        let eolSearchPageSlug = $('table.ioe').data('eolPageUrl');
                        let searchHistoryEOL = localStorage.getItem('search_history_eol');
                        if (searchHistoryEOL === null) {
                            searchHistoryEOL = [];
                        } else {
                            searchHistoryEOL = JSON.parse(searchHistoryEOL)
                        }

                        if (searchValue.length) {
                            if (searchHistoryEOL.length >= searchHistoryEOLCount) {
                                pushToLS('search_history_eol', searchValue, true);
                            } else {
                                pushToLS('search_history_eol', searchValue);
                            }
                        }

                        $('body').addClass('loading');

                        if ('URLSearchParams' in window) {
                            if (searchValue.length) {
                                var searchParams = new URLSearchParams();
                                searchParams.set(searchParamName, searchValue);
                                window.location.href = eolSearchPageSlug + '?' + searchParams.toString();
                            } else {
                                window.location.href = eolSearchPageSlug;
                            }
                        }
                    });

                    $('body').on('click', '.js-suggestions-list-eol a', function (e) {
                        e.preventDefault();
                        $searchInputEol.val($(this).text());
                        $searchBoxEol.submit();
                    })

                    $(document).mouseup(function (e) {
                        if (!$searchBoxEol.is(e.target) && $searchBoxEol.has(e.target).length === 0) {
                            $searchBoxEol.find(".search__suggestions-close").trigger("click")
                        }
                    });
                }
                $('body').on('click', '.js-notice-close', function (e) {
                    e.preventDefault();
                    let $notice = $(this).closest('.notice');

                    let time = $notice.data('time');
                    let id = $notice.data('id');

                    if (time !== 0) {
                        pushToLS('notices', id);
                    }

                    $notice.fadeOut(200);
                    localStorage.modalCovid = $($notice).hasClass("covid-notice")

                });
                $('body').on('click', '.js-modal', function (e) {
                    e.preventDefault();
                    let $this = $(this);
                    let modalId = 'modal-' + $this.data('modal');

                    $('.mobile-nav__close').trigger('click');
                    openModal(modalId);
                })

                $('body').on('click', '.js-modal-get-a-sample, .js-modal-get-a-sample-models-list', function (e) {
                    e.preventDefault();
                    let $btn = $(this);
                    let modalId = 'modal-' + $btn.data('modal');
                    let $modal = $('#' + modalId);
                    let category = $btn.data('category');
                    let $partsCheckboxes = $('#form-part-numbers').find(':checked');
                    let data = [];
                    let product = $btn.data('product');
                    if (window.tdParts && partsCheckboxes) {
                        $partsCheckboxes.each(function () {
                            let partId = $(this).val();
                            let part = window.tdParts[partId];
                            data.push(
                                part.title
                            );
                        });
                        product = data.toString();
                    }

                    if ($modal.length) {
                        let $productWrapper = $modal.find('.js-get-a-sample-product-wrapper');
                        let $categoryWrapper = $modal.find('.js-get-a-sample-category-wrapper');
                        let $productText = $modal.find('.js-get-a-sample-product');
                        let $categoryText = $modal.find('.js-get-a-sample-category');
                        let $productInput = $modal.find('.js-input-product');
                        let $categoryInput = $modal.find('.js-input-category');
                        $productWrapper.hide();
                        $categoryWrapper.hide();
                        if (product && product.length) {
                            $productWrapper.show();
                            $productText.html(product);
                            $productInput.val(product);
                        }
                        if (category && category.length) {
                            $categoryWrapper.show();
                            $categoryText.html(category);
                            $categoryInput.val(category);
                        }
                    }
                    openModal(modalId);
                });

                var callback = function () {
                    if ($('body').find('#pi_tracking_opt_in_div').length === 0) {
                        setTimeout(callback, '100');
                        return;
                } else {
                        $('body').find('#pi_tracking_opt_in_div').hide();
                }};
                callback();
                var cookieConsent = localStorage.getItem("accept_cookies");

                if (cookieConsent === null) {
                    gtag('consent', 'default', {
                        ad_storage: 'granted',
                        analytics_storage: 'granted',
                        ad_user_data: 'granted',
                        ad_personalization: 'granted'
                    });
                    gtag('consent', 'update', {
                        ad_storage: 'granted',
                        analytics_storage: 'granted',
                        ad_user_data: 'granted',
                        ad_personalization: 'granted'
                    });
                } else {
                    if (cookieConsent == 'true' ) {
                        gtag('consent', 'default', {
                            ad_storage: 'granted',
                            analytics_storage: 'granted',
                            ad_user_data: 'granted',
                            ad_personalization: 'granted'
                        });
                        gtag('consent', 'update', {
                            ad_storage: 'granted',
                            analytics_storage: 'granted',
                            ad_user_data: 'granted',
                            ad_personalization: 'granted'
                        });
                        setToLS('accept_cookies', true);
                    } else {
                        gtag('consent', 'default', {
                            ad_storage: 'denied',
                            analytics_storage: 'denied',
                            ad_user_data: 'denied',
                            ad_personalization: 'denied'
                        });
                        gtag('consent', 'update', {
                            ad_storage: 'denied',
                            analytics_storage: 'denied',
                            ad_user_data: 'denied',
                            ad_personalization: 'denied'
                        });
                        setToLS('accept_cookies', false);
                        $('body').find('.js-notice-close').trigger('click');
                    }
                }

                    $('body').on('click', '.js-notice-cookies-accept', function (e) {
                        e.preventDefault();
                        let $notice = $(this).closest('.notice');
                        $('body').find('#pi_tracking_opt_in_yes').trigger('click');
                        setToLS('accept_cookies', true);
                        gtag('consent', 'update', {
                            ad_storage: 'granted',
                            analytics_storage: 'granted',
                            ad_user_data: 'granted',
                            ad_personalization: 'granted'
                        });

                        $notice.find('.js-notice-close').trigger('click');
                    });

                    $('body').on('click', '.js-notice-cookies-reject', function (e) {
                        e.preventDefault();
                        gtag('consent', 'update', {
                            ad_storage: 'denied',
                            analytics_storage: 'denied',
                            ad_user_data: 'denied',
                            ad_personalization: 'denied'
                        });

                        $('body').find('#pi_tracking_opt_in_no').trigger('click');
                        $('body').find('.js-notice-close').trigger('click');
                        let $notice = $(this).closest('.notice');
                        setToLS('accept_cookies', false);
                        window.localStorage.setItem("accept_cookies", 'false');
                        $notice.find('.js-notice-close').trigger('click');
                    });


                $('body').on('click', '.notice__close_x_button', function (e) {
                    e.preventDefault();
                    let $notice = $(this).closest('.notice');
                    $('body').find('#pi_tracking_opt_in_div').hide();
                    $notice.find('.js-notice-close').trigger('click');
                });

            });
            function setCheckbox($elem, type) {
                if (type === 'radio') {
                    let radioName = $elem.attr('name');
                    let $parentForm = $elem.closest('form');
                    $parentForm.find('input[name="' + radioName + '"]').each(function () {
                        $(this).prev('.' + type).removeClass('checked');
                    });
                }

                if ($elem.is(':disabled')) {
                    $elem.prev('.' + type).addClass('disabled');
                }
                if ($elem.is(':checked')) {
                    $elem.prev('.' + type).addClass('checked');
                } else {
                    $elem.prev('.' + type).removeClass('checked');
                }
            }

            function drawStyledCheckboxes() {
                let $checkboxes = $('.js-checkbox-styled-simple');

                $checkboxes.each(function () {
                    let $checkbox = $(this);
                    let $prevElement = $checkbox.prev();

                    if ($prevElement.hasClass('checkbox--styled--simple')) {
                        setCheckbox($checkbox, 'checkbox');
                    } else {
                        $checkbox.before('<span class="checkbox checkbox--styled--simple">');
                        setCheckbox($checkbox, 'checkbox');
                    }
                });
            }

            function drawStyledToggles() {
                let $checkboxes = $('.js-checkbox-styled-toggle');

                $checkboxes.each(function () {
                    let $checkbox = $(this);
                    let $prevElement = $checkbox.prev();
                    if ($prevElement.hasClass('checkbox--styled--simple')) {
                        setCheckbox($checkbox, 'checkbox');
                    } else {
                        $checkbox.before('<span class="checkbox checkbox--styled--toggle">');
                        setCheckbox($checkbox, 'checkbox');
                    }
                });
            }

            function drawStyledRadios() {
                let $radios = $('.js-radio-styled');

                $radios.each(function () {
                    let $radio = $(this);
                    let $prevElement = $radio.prev();
                    if ($prevElement.hasClass('radio--styled')) {
                        setCheckbox($radio, 'radio');
                    } else {
                        $radio.before('<span class="radio radio--styled">');
                        setCheckbox($radio, 'radio');
                    }
                });
            }
            function drawStyledElements() {
                drawStyledCheckboxes();
                drawStyledToggles();
                drawStyledRadios();
            }
            drawStyledElements();
            window.drawStyledElements = drawStyledElements;

            $('body').on('change', '.js-checkbox-styled-simple, .js-checkbox-styled-toggle', function () {
                setCheckbox($(this), 'checkbox');
            });

            $('body').on('change', '.js-radio-styled', function () {
                setCheckbox($(this), 'radio');
            });

            function getCookie(cname) {
                let name = cname + "=";
                let decodedCookie = decodeURIComponent(document.cookie);
                let ca = decodedCookie.split(';');
                for (let i = 0; i < ca.length; i++) {
                    let c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return "";
            }

            $(document).on('submit', '.js-form', function (e) {
                e.preventDefault();
                if (typeof grecaptcha !== 'undefined' && typeof $(this).data('captcha_id') !== "undefined") {
                    var captchaResponse = grecaptcha.getResponse($(this).data('captcha_id'));
                    if (captchaResponse.length == 0 && $(this).find(".form-captcha").length) {
                        $(this).find(".form-captcha").find('.captcha-error').remove();
                        $(this).find(".form-captcha").append('<p class="captcha-error">You can\'t leave Captcha empty</p>');
                        setTimeout(function () {
                            $('.captcha-error').remove();
                        }, 2000);
                        return false;
                    }
                }
                formHandler($(this));
            });

            function formHandler($form) {
                let data = $form.serialize();
                let formType = $form.data('form');
                let $modal = $form.closest('.modal');
                data += '&form_type=' + formType + '&action=form_handler';
                if (!window.ajaxUrl) {
                    window.ajaxUrl = location.origin + '/wp-admin/admin-ajax.php';
                }

                $.ajax({
                    url: window.ajaxUrl,
                    type: 'POST',
                    dataType: 'json',
                    data: data,
                    beforeSend: function (xhr) {
                        $form.addClass('loading');
                    },
                    complete: function (xhr) {
                        $form.removeClass('loading');
                    },
                    error: function (xhr, status, error) {
                        $form.removeClass('loading');
                    },
                    success: function (response) {
                        if ($modal && response.type !== 'file') {
                            $modal.modal('close');
                        }

                        if (response.success) {
                            if (response.type === 'thanks') {
                                let $thanksModal = $('#modal-thank-you');
                                if (response.message) {
                                    $thanksModal.find('.thank-you-message').html(response.message);
                                }
                                if (formType === 'ccpa-request') {
                                    $thanksModal.find('p').html('');
                                }
                                $thanksModal.modal('show');
                            } else if (response.type === 'file') {
                                let fileId = 'file-' + Date.now();

                                if (!getCookie('file_cookie_2')) {
                                    let date = new Date();
                                    date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000)); //expire in 1 year
                                    const expires = "expires=" + date.toUTCString();
                                    indexed_array = {};

                                    $.map($form.serializeArray(), function (n, i) {

                                        indexed_array[n['name']] = n['value'];
                                    });
                                    delete (indexed_array['conversion-point']);
                                    delete (indexed_array['Website_Conversion_Page']);
                                    delete (indexed_array['id']);
                                    delete (indexed_array['source']);
                                    form_json = JSON.stringify(indexed_array);

                                    document.cookie = "file_cookie_2=" + form_json + "; " + expires + "; path=/";
                                }
                                $modal.find('#form-free-download').hide();
                                $('.returned-download').attr('id', fileId);
                                $('.returned-download').attr("href", response.file);
                                if (response.file_name) $('.returned-download').attr('download', response.file_name);
                                else $('.returned-download').removeAttr('download');
                                $('.returned-download').show();
                                //$('#' + fileId)[0].click();
                                $modal.modal('show');
                            }

                            $form[0].reset();
                        } else {
                            let $errorModal = $('#modal-error-send-form');
                            $errorModal.modal('show');
                        }
                    }
                });
            }
        }

        $(document).on('change', 'select', function () {
            let $select = $(this);
            if ($select.children("option:selected").attr('value')) {
                $select.addClass('selected');
            } else {
                $select.removeClass('selected');
            }
        });

        if (!$.fn.sortElements) {
            $.fn.sortElements = (function () {
                var sort = [].sort;
                return function (comparator, getSortable) {
                    getSortable = getSortable || function () {
                        return this;
                    };

                    var placements = this.map(function () {
                        var sortElement = getSortable.call(this),
                            parentNode = sortElement.parentNode,
                            nextSibling = parentNode.insertBefore(
                                document.createTextNode(''),
                                sortElement.nextSibling
                            );

                        return function () {
                            if (parentNode === this) {
                                throw new Error(
                                    "You can't sort elements if any one is a descendant of another."
                                );
                            }
                            parentNode.insertBefore(this, nextSibling);
                            parentNode.removeChild(nextSibling);
                        };
                    });

                    return sort.call(this, comparator).each(function (i) {
                        placements[i].call(getSortable.call(this));
                    });
                };
            })();
        }

        if ($.fn.swipebox) {
            $(document).swipebox({ selector: '.swipebox' });
        }

        window.getCookie = getCookie;

        function jsTableColumnSorter(column) {
            let $table = column.closest('table');
            let $container = $table.parent();
            let $th = column;
            let thIndex = $th.index();
            let inverse = false;

            $th.click(function () {
                let thSelect = 'thead > tr > th';
                let sortType = $table.data('sort-type');
                if ($container.hasClass('wptb-table-container') && $table.hasClass('wptb-header-first-row')) {
                    thSelect = 'tbody > tr:first-child > td';
                }

                $table.find(thSelect).each(function () {
                    if (this !== $th[0]) {
                        column.removeClass('up down');
                    }
                });

                if ($th.hasClass('up')) {
                    $th.removeClass('up');
                    $th.addClass('down');
                } else if ($th.hasClass('down')) {
                    $th.removeClass('down');
                    $th.addClass('up');
                } else {
                    if (inverse) {
                        $th.addClass('up');
                    } else {
                        $th.addClass('down');
                    }
                }

                if (!sortType || sortType === 'plain') {
                    let trSelect = 'tbody > tr';
                    if ($container.hasClass('wptb-table-container') && $table.hasClass('wptb-header-first-row')) {
                        trSelect = 'tbody > tr:not(:first)';
                    }
                    $table.find(trSelect).hide();
                    $table.find(trSelect + ' > td').filter(function () {
                        return column.index() === thIndex;
                    }).sortElements(function (a, b) {
                        var ia = parseFloat($(a).html().replace(/<\/?[^>]+(>|$)/g, ""));
                        var ib = parseFloat($(b).html().replace(/<\/?[^>]+(>|$)/g, ""));

                        /*FIX_FILTER*/
                        var html_a = $(a).html();
                        var html_i = $(b).html();
                        var match_a = /\s\d+(\.\d+)?\s/g.exec(html_a);
                        if (match_a != null) {
                            ia = parseFloat(match_a[0].trim());
                        }
                        var match_i = /\s\d+(\.\d+)?\s/g.exec(html_i);
                        if (match_i != null) {
                            ib = parseFloat(match_i[0].trim());
                        }
                        /*FIX_FILTER_END*/

                        if (!isNaN(ia) && !isNaN(ib)) {
                            return ia > ib ? (inverse ? -1 : 1) : (inverse ? 1 : -1);
                        }
                        return $.text([a]) > $.text([b]) ? inverse ? -1 : 1 : inverse ? 1 : -1;
                    }, function () {
                        // parentNode is the element we want to move
                        return this.parentNode;
                    });

                    $table.find(trSelect).fadeIn(200);
                    inverse = !inverse;
                } else { // sortType === 'ajax'
                    let $filterForm = $table.closest('form.filter');
                    let $sortField, $orderField;

                    if (!$filterForm.length) {
                        console.debug('Element \'form\' does not exist');
                    } else {
                        $sortField = $filterForm.find('.sort-filter');
                        $orderField = $filterForm.find('.order-filter');
                        let columnId = $th.data('id');

                        const $bypassInventory = $filterForm.find('input[name="bypass_inventory"]');
                        if( ! isNaN(parseInt(columnId)) && $bypassInventory.length && $bypassInventory.val() == 1 ) {
                            columnId = 'd' + columnId;
                        }

                        if (!$sortField.length) {
                            console.debug('Element with class \'sort-filter\' does not exist');
                        }

                        if (!$orderField.length) {
                            console.debug('Element with class \'order-filter\' does not exist');
                        }

                        if ($sortField.length && $orderField.length) {
                            if (inverse) {
                                $sortField.val('asc');
                            } else {
                                $sortField.val('desc');
                            }

                            $orderField.val(columnId);
                            $filterForm.trigger('filter');

                            inverse = !inverse;
                        }
                    }
                }
            });
        }

        window.jsTableColumnSorter = jsTableColumnSorter;

        $('.js-table-column-sorter').each(function () {
            jsTableColumnSorter($(this));
        });

        init();
    });
})(jQuery, window, document);



